// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/NHaasGroteskDSPro-45Lt.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/NHaasGroteskDSPro-55Rg.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/NeueHaasDisplayMedium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/NeueHaasDisplayBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/NHaasGroteskTXPro-55Rg.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/NHaasGroteskTXPro-65Md.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/NHaasGroteskTXPro-75Bd.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Neue Haas Grotesk Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: 300;
  font-display: swap;
}

@font-face {
  font-family: "Neue Haas Grotesk Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

@font-face {
  font-family: "Neue Haas Grotesk Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-style: normal;
  font-weight: 500 600;
  font-display: swap;
}

@font-face {
  font-family: "Neue Haas Grotesk Display";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-style: normal;
  font-weight: 700;
  font-display: swap;
}

@font-face {
  font-family: "Neue Haas Grotesk Text";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

@font-face {
  font-family: "Neue Haas Grotesk Text";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-style: normal;
  font-weight: 500;
  font-display: swap;
}

@font-face {
  font-family: "Neue Haas Grotesk Text";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-style: normal;
  font-weight: 700;
  font-display: swap;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui-components/src/styles/specra-fonts.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,+DAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,+DAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,+DAAwE;EACxE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,+DAAsE;EACtE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,+DAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,+DAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,+DAAyE;EACzE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: \"Neue Haas Grotesk Display\";\n  src: url(\"../assets/fonts/NHaasGroteskDSPro-45Lt.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display\";\n  src: url(\"../assets/fonts/NHaasGroteskDSPro-55Rg.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display\";\n  src: url(\"../assets/fonts/NeueHaasDisplayMedium.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: 500 600;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Display\";\n  src: url(\"../assets/fonts/NeueHaasDisplayBold.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Text\";\n  src: url(\"../assets/fonts/NHaasGroteskTXPro-55Rg.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Text\";\n  src: url(\"../assets/fonts/NHaasGroteskTXPro-65Md.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk Text\";\n  src: url(\"../assets/fonts/NHaasGroteskTXPro-75Bd.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
